module.exports = __webpack_public_path__ + "img/banker-purple-promotions.30376e2e.png";